import axiosClientDistribution from "axiosClient/indexDistribution";
import { getQueryString } from "utilities/common";

export async function getKitRefillLogsDateWiseAPI(data) {
  return await axiosClientDistribution.get(`api/v1/blaze/distribution/check/sold/driver?${getQueryString(data)}`)
}
